const getActiveLocaleFromUrl = () => {
  if (global.window
    && global.window.location
    && global.window.location.pathname) {
    const [,
      activeLocale = '',
    ] = global.window.location.pathname.split('/');
    const [lang, market] = activeLocale.split('-');
    if (lang && market) {
      return `${lang}-${market.toUpperCase()}`;
    }
  }
  return null;
};

export default getActiveLocaleFromUrl;
